import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import { Icon, Banner } from '@arnsbogroup/react-voicearchive'

const LandingPageLink = ({ attribute, state, onChange }) => {
  const { key, name, title, value, hidden} = attribute
  const { formatMessage } = useIntl()
  const [copied, setCopied] = useState(false)

  const onCopy = () => {
    navigator.clipboard.writeText(value)
    setCopied(true)
    toastr.success(formatMessage(messages.copySuccess))
  }

  return (
    <fieldset key={key} className={`space-y-2 ${hidden ? 'hidden' : 'block'}`}>
      <Banner
        title={name}
        state="success"
      />
      <div className="border border-gray-200 rounded-md overflow-hidden">
          <p className="p-4 bg-gray-50 text-sm text-gray-700 border-b border-gray-200 whitespace-pre-line">
            <FormattedMessage {...messages.description} />
          </p>
          <div
            className="flex items-center justify-between p-4 bg-white text-gray-800 cursor-pointer hover:bg-gray-50"
            onClick={onCopy}
          >
            <span className="truncate text-xs text-gray-600">{value}</span>
            <Icon
              icon={['fas', copied ? 'check' : 'share']}
              className={`text-gray-500 hover:text-gray-800 transition ${copied ? 'text-green-600' : ''}`}
            />
          </div>
        </div>
    </fieldset>
  )
}

export default LandingPageLink
